// WashU's undergraduate majors (#2652, batch 2). Read on 2026-10-01 from the
// official 2026-27 Bulletin, Majors (all schools) (bulletin.wustl.edu/
// undergrad/majors/), grouped by the school each entry links to. Left out:
// second majors, specializations within a major, concentrations of a major
// that is itself listed (Art BFA, Design BA, Music BMus) and the Double
// Majors and Pre-Medical Program note. Majors offered only as concentrations
// (Global Studies, Jewish, Islamic, and Middle Eastern Studies,
// Philosophy-Neuroscience-Psychology) are kept as listed. Arts & Sciences
// entries name no degree in the list, so `degree` is null there; the word
// 'Major' is dropped from names. The KB's list was the starting point.
const majors = {
    "slug": "washington-university-in-st-louis",
    "read": "2026-10-01",
    "intro": "Every undergraduate major in WashU's official 2026-27 Bulletin, grouped by the school that offers it, with the degree where the Bulletin names one. Second majors, specializations, minors and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Architecture",
            "source": {
                "label": "WashU Bulletin 2026-27, Majors (all schools)",
                "url": "https://bulletin.wustl.edu/undergrad/majors/"
            },
            "note": "Portfolios are strongly encouraged for applicants to the College of Architecture.",
            "noteSource": "portfolio",
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "BA or BS"
                }
            ]
        },
        {
            "name": "College of Art",
            "source": {
                "label": "WashU Bulletin 2026-27, Majors (all schools)",
                "url": "https://bulletin.wustl.edu/undergrad/majors/"
            },
            "note": "A portfolio is required for applicants to the College of Art.",
            "noteSource": "portfolio",
            "majors": [
                {
                    "name": "Art",
                    "degree": "BA or BFA"
                },
                {
                    "name": "Communication Design",
                    "degree": "BFA"
                },
                {
                    "name": "Design",
                    "degree": "BA"
                },
                {
                    "name": "Fashion Design",
                    "degree": "BFA"
                }
            ]
        },
        {
            "name": "College of Arts & Sciences",
            "source": {
                "label": "WashU Bulletin 2026-27, Majors (all schools)",
                "url": "https://bulletin.wustl.edu/undergrad/majors/"
            },
            "majors": [
                {
                    "name": "African & African American Studies",
                    "degree": null
                },
                {
                    "name": "American Culture Studies",
                    "degree": null
                },
                {
                    "name": "Ancient Studies",
                    "degree": null
                },
                {
                    "name": "Anthropology",
                    "degree": null
                },
                {
                    "name": "Applied Mathematics",
                    "degree": null
                },
                {
                    "name": "Arabic",
                    "degree": null
                },
                {
                    "name": "Art History and Archaeology",
                    "degree": null
                },
                {
                    "name": "Astrophysics",
                    "degree": null
                },
                {
                    "name": "Biochemistry",
                    "degree": null
                },
                {
                    "name": "Biology",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": null
                },
                {
                    "name": "Classics",
                    "degree": null
                },
                {
                    "name": "Comparative Literature and Thought",
                    "degree": null
                },
                {
                    "name": "Dance",
                    "degree": null
                },
                {
                    "name": "Data Science",
                    "degree": null
                },
                {
                    "name": "Drama",
                    "degree": null
                },
                {
                    "name": "Earth Science",
                    "degree": null
                },
                {
                    "name": "East Asian Languages and Cultures",
                    "degree": null
                },
                {
                    "name": "Economics and Computer Science",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "Educational Studies",
                    "degree": null
                },
                {
                    "name": "English Literature",
                    "degree": null
                },
                {
                    "name": "Environmental Analysis",
                    "degree": null
                },
                {
                    "name": "Environmental Biology",
                    "degree": null
                },
                {
                    "name": "Environmental Policy",
                    "degree": null
                },
                {
                    "name": "Environmental Science",
                    "degree": null
                },
                {
                    "name": "Film and Media Studies",
                    "degree": null
                },
                {
                    "name": "French",
                    "degree": null
                },
                {
                    "name": "Germanic Languages and Literatures",
                    "degree": null
                },
                {
                    "name": "Global Studies, Development Concentration",
                    "degree": null
                },
                {
                    "name": "Global Studies, Eurasian Studies Concentration",
                    "degree": null
                },
                {
                    "name": "Global Studies, European Studies Concentration",
                    "degree": null
                },
                {
                    "name": "Global Studies, Global Asias Concentration",
                    "degree": null
                },
                {
                    "name": "Global Studies, Global Cultural Studies Concentration",
                    "degree": null
                },
                {
                    "name": "Global Studies, International Affairs Concentration",
                    "degree": null
                },
                {
                    "name": "Hebrew",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "Italian",
                    "degree": null
                },
                {
                    "name": "Jewish, Islamic, and Middle Eastern Studies, Comparative Jewish and Islamic Studies Concentration",
                    "degree": null
                },
                {
                    "name": "Jewish, Islamic, and Middle Eastern Studies, Modern Middle Eastern Studies Concentration",
                    "degree": null
                },
                {
                    "name": "Latin American Studies",
                    "degree": null
                },
                {
                    "name": "Linguistics",
                    "degree": null
                },
                {
                    "name": "Mathematical Sciences",
                    "degree": null
                },
                {
                    "name": "Mathematics and Computer Science",
                    "degree": null
                },
                {
                    "name": "Mathematics and Economics",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Music",
                    "degree": "BA or BMus"
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Philosophy-Neuroscience-Psychology, Cognitive Neuroscience Concentration",
                    "degree": null
                },
                {
                    "name": "Philosophy-Neuroscience-Psychology, Language Cognition and Culture Concentration",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                },
                {
                    "name": "Planetary Science",
                    "degree": null
                },
                {
                    "name": "Political Science",
                    "degree": null
                },
                {
                    "name": "Psychological & Brain Sciences",
                    "degree": null
                },
                {
                    "name": "Psychological & Brain Sciences: Cognitive Neuroscience",
                    "degree": null
                },
                {
                    "name": "Public Health & Society",
                    "degree": null
                },
                {
                    "name": "Religious Studies",
                    "degree": null
                },
                {
                    "name": "Romance Languages and Literatures",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                },
                {
                    "name": "Spanish",
                    "degree": null
                },
                {
                    "name": "Statistics",
                    "degree": null
                },
                {
                    "name": "Women, Gender, and Sexuality Studies",
                    "degree": null
                }
            ]
        },
        {
            "name": "Olin Business School",
            "source": {
                "label": "WashU Bulletin 2026-27, Majors (all schools)",
                "url": "https://bulletin.wustl.edu/undergrad/majors/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BSBA"
                },
                {
                    "name": "Economics and Strategy",
                    "degree": "BSBA"
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "BSBA"
                },
                {
                    "name": "Finance",
                    "degree": "BSBA"
                },
                {
                    "name": "Health Care Management",
                    "degree": "BSBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BSBA"
                },
                {
                    "name": "Organization and Strategic Management",
                    "degree": "BSBA"
                },
                {
                    "name": "Supply Chain, Operations, and Technology",
                    "degree": "BSBA"
                }
            ]
        },
        {
            "name": "McKelvey School of Engineering",
            "source": {
                "label": "WashU Bulletin 2026-27, Majors (all schools)",
                "url": "https://bulletin.wustl.edu/undergrad/majors/"
            },
            "majors": [
                {
                    "name": "Applied Science (Chemical Engineering) (EECE)",
                    "degree": "BS"
                },
                {
                    "name": "Applied Science (Electrical Engineering) (ESE)",
                    "degree": "BS"
                },
                {
                    "name": "Applied Science (Mechanical Engineering) (MEMS)",
                    "degree": "BS"
                },
                {
                    "name": "Applied Science (Systems Science & Engineering) (ESE)",
                    "degree": "BS"
                },
                {
                    "name": "Biomedical Engineering (BME)",
                    "degree": "BS"
                },
                {
                    "name": "Business and Computer Science (CSE)",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering (EECE)",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering (CSE)",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering (ESE)",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science (CSE)",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science + Economics (CSE)",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science + Mathematics (CSE)",
                    "degree": "BS"
                },
                {
                    "name": "Data Science (CSE)",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering (ESE)",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Engineering (EECE)",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering (MEMS)",
                    "degree": "BS"
                },
                {
                    "name": "Systems Science & Engineering (ESE)",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
